<script>
  export let data = { groups: [] },
    contact;

  const groups = data.groups || [];
</script>

<ul>
  {#each groups as group}
    {#if group}
      <li><b>{group.name}</b></li>
    {/if}
  {/each}
</ul>
